import { render, staticRenderFns } from "./Select-Email-Configuration.vue?vue&type=template&id=d385ea80&scoped=true&"
import script from "./Select-Email-Configuration.vue?vue&type=script&lang=js&"
export * from "./Select-Email-Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Select-Email-Configuration.vue?vue&type=style&index=0&id=d385ea80&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d385ea80",
  null
  
)

export default component.exports